import script from "./MiningCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./MiningCompany.vue?vue&type=script&setup=true&lang=js"

import "./MiningCompany.vue?vue&type=style&index=0&id=19383ecb&lang=scss"

const __exports__ = script;

export default __exports__